import { motion } from 'framer-motion';
import { t } from 'i18next';
import { ReactComponent as ChevronDownIcon } from '../../icons/chevron.down.small.svg';

interface NewMessageAlertButtonProps {
  show: boolean;
  onClick: () => void;
  styleVariant?: 'default' | 'trading';
}

export default function NewMessageAlertButton({
  show,
  onClick,
  styleVariant = 'default'
}: NewMessageAlertButtonProps): JSX.Element | null {
  if (!show) return null;

  const baseClasses = "fixed text-onPrimary px-[16px] py-[8px] rounded-full flex items-center space-x-2 z-50" +
    " bg-[radial-gradient(50%_100.4%_at_50%_100%,#C3A9FF_0%,#8068FF_100%)] border-[1.5px] border-solid border-white" +
    " shadow-[0px_2px_10px_0px_rgba(92,61,250,0.3),0px_0px_4px_0px_rgba(92,61,250,0.4)]";

  const positionClasses = styleVariant === 'trading'
    ? "bottom-24"
    : "bottom-20";

  return (
    <motion.div
      initial={{ opacity: 0, x: '-50%', y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 20 }}
      onClick={onClick}
      className={`${baseClasses} ${positionClasses} left-1/2`}
    >
      <span className="text-[15px] font-semibold shadow-[0px_1px_2px_0px_rgba(0,0,0,0.08)]">
        {t('DMChatRoom.newMessage', { defaultValue: '새 메시지 보기' })}
      </span>
      <ChevronDownIcon className="w-[16px] h-[16px] fill-white" />
    </motion.div>
  );
}
